import React from 'react'

const TramitesYServicios = () => {
  return (
    <div>TramitesYServicios</div>
  )
}

export default TramitesYServicios